/**
 * Shared sizing for every control-plane button in the opener AND unwinder page
 * headers — Stop/Start, Boot/Shutdown control plane, PANIC, the per-group pod
 * controls, Finish, and the venue-maintenance Resume.
 *
 * Two things it enforces:
 *   - `whiteSpace: 'nowrap'`: without it a multi-word label ("Boot control
 *     plane", "Reset to default") wraps INSIDE the button and the whole header
 *     renders double-height. The operator was running the browser at 80% zoom
 *     purely to avoid that.
 *   - a font/padding/icon scale tight enough that the two header rows fit on
 *     ONE line each at 100%. Their Stacks wrap the button GROUP instead, so a
 *     genuinely narrow screen degrades by moving buttons down, never by making
 *     any single button two lines tall.
 *
 * It covers both domains because `VenueMaintenanceControl` renders in both
 * headers: sizing it on one side alone leaves it visibly odd on the other.
 *
 * Kept in its own module (not next to the components that use it) so importing
 * it never pulls a whole control-plane component — with its query hooks — into
 * another module's graph.
 */
export const HEADER_CONTROL_BTN_SX = {
  fontSize: '0.64rem',
  py: 0.15,
  px: 0.7,
  minWidth: 0,
  whiteSpace: 'nowrap',
  flexShrink: 0,
  '& .MuiButton-startIcon': {
    mr: 0.4,
    ml: 0,
    '& > *:first-of-type': { fontSize: 14 }
  }
} as const;
